import { render, staticRenderFns } from "./gas-consumption-card.vue?vue&type=template&id=e7c2ab44&scoped=true&"
import script from "./gas-consumption-card.vue?vue&type=script&lang=ts&"
export * from "./gas-consumption-card.vue?vue&type=script&lang=ts&"
import style0 from "./gas-consumption-card.vue?vue&type=style&index=0&id=e7c2ab44&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7c2ab44",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard,VCardTitle})
